import { Injectable, inject } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { get } from 'lodash';
import { Observable, map } from 'rxjs';
import {
  HealthScoreReportRecommendationQueriesFindAllArgs,
  HealthScoreReportRecommendationResult
} from '../../../../../interfaces/schema';

/**
 * @description HomeMyRecommendationGeneralHealth Service.
 * @exports
 * @class HomeMyRecommendationGeneralHealthService
 */
@Injectable()
export class HomeMyRecommendationGeneralHealthService {
  private readonly apollo: Apollo = inject(Apollo);

  /**
   * @description Fetch recommendations.
   * @param {HealthScoreReportRecommendationQueriesFindAllArgs} [variables] Params.
   * @returns {Observable<HealthScoreReportRecommendationResult>}
   * @memberof HomeMyRecommendationGeneralHealthService
   */
  recommendations(
    variables?: HealthScoreReportRecommendationQueriesFindAllArgs
  ): Observable<HealthScoreReportRecommendationResult> {
    const query = gql`
      query findAllHSRecommendation(
        $sort: HealthScoreReportRecommendationSortBy
        $where: HealthScoreReportRecommendationFilter
        $limit: Int
        $offset: Int
      ) {
        HealthScore {
          Report {
            Recommendation {
              findAll(
                where: $where
                sort: $sort
                limit: $limit
                offset: $offset
              ) {
                count
                results {
                  id
                  category
                  subCategory
                  recommendation
                  dos
                  donts
                  finding {
                    selfAssessment
                    medicalTest
                    geneticAnalysis
                  }
                  relatedDNATraits
                  references
                  isRelevant
                  healthScoreReportId
                  createdAt
                  updatedAt
                }
              }
            }
          }
        }
      }
    `;
    return this.apollo
      .query({ query, variables })
      .pipe(
        map(
          ({ data }) =>
            get(
              data as any,
              'HealthScore.Report.Recommendation.findAll'
            ) as HealthScoreReportRecommendationResult
        )
      );
  }
}
